import { useOutletContext, useParams } from "react-router";
import { useEffect, useState } from "react";
import axios from "axios";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import ProductView from "./component/productView";

import { Container } from "../common/styled";

const ProductsView = () => {
  const { cmpnyNo, homepageInfo, theme } = useOutletContext();
  const { prdNo } = useParams();

  const [product, setProduct] = useState();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (cmpnyNo) {
      getCmpnyPrductList();
      getOption();
    }
  }, [cmpnyNo]);

  const getCmpnyPrductList = async () => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
      query VendorProducts(
        $id: ID
        $cmpnyNo: Int!
      ) {
        vendorProducts(
          filter: {
            id: $id
            cmpnyNo: $cmpnyNo
          }
        ) {
          totalCount
          products {
            id
            description
            specifications
            cmpnyNo
            name            
            brand
            categoryId
            media            
            quantity
            price
          }
        }
      }
    `;

      const variables = { cmpnyNo: parseInt(cmpnyNo, 10), id: prdNo };
      const body = { query, variables };
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setProduct(res.data.products?.[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOption = async () => {
    const url = "/erp/option/get";
    const body = { vendorProductId: prdNo, admin: false };
    try {
      const res = await axios.post(url, body);
      setOptions(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  const renderContent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner && <Banner />}
        <ProductView product={product} options={options} setOptions={setOptions} />
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderContent()}</Container>;
};

export default ProductsView;
